module.exports = __webpack_public_path__ + "img/chris-red.41fdd133.png";